// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* "What you get" mockup for the Deploy → Channels modals.
   Everything inside \`.cpreview-stage\` is drawn at the SHIPPED pixel sizes and
   the whole stage is scaled by JS, so these numbers must stay equal to the
   real ones. Sources are named per block:
     [W] ultimo-bots-widget/src/index.js   (Shadow-DOM panel)
     [H] ultimo-bots-frontend/src/Chat.css (hosted chat page)  */

.cpreview {
  position: relative;
  /* LOAD-BEARING: the portal has no global border-box reset, so \`width: 100%\`
     plus the 1px border made this 2px wider than the modal's content column.
     \`.channel-modal-body\` sets \`overflow-y: auto\`, which computes overflow-x to
     \`auto\` as well, so those 2px — the entire right border — were clipped out
     of view. Measured: scrollWidth 782 vs clientWidth 780. */
  box-sizing: border-box;
  width: 100%;
  /* Matches the 1440x810 stage, so the scaled stage fills the band exactly. */
  aspect-ratio: 16 / 9;
  margin-bottom: 18px;
  border-radius: 12px;
  overflow: hidden;
  background: #f4f2f9;
  border: 1px solid #e8e3f5;
}

/* The Integration tab (Chat link) is a flex column with its own 15px gap, so
   the band's own bottom margin would double the spacing there. */
.integration-tab-content > .cpreview {
  margin-bottom: 0;
}

.cpreview-stage {
  transform-origin: top left;
  font-family: "DM Sans", sans-serif;
  /* The stage carries no interactivity — it is a picture. */
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

/* ── Browser chrome ─────────────────────────────────────────────────── */
.cp-browser {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}
.cp-browser-bar {
  flex: 0 0 auto;
  height: 52px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 20px;
  background: #ece9f4;
  border-bottom: 1px solid #ded9ec;
}
/* macOS traffic lights (close / minimise / zoom), in the order and colours
   Aqua uses since Big Sur. The three dots are the first three children of
   .cp-browser-bar; .cp-url follows them. */
.cp-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #cdc7dd;
}
.cp-dot:first-child { margin-left: 4px; }
.cp-browser-bar .cp-dot:nth-child(1) { background: #ff5f57; }
.cp-browser-bar .cp-dot:nth-child(2) { background: #febc2e; }
.cp-browser-bar .cp-dot:nth-child(3) { background: #28c840; }
.cp-url {
  margin-left: 14px;
  height: 30px;
  min-width: 320px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  border-radius: 15px;
  background: #fff;
  color: #8a8496;
  font-size: 14px;
}
.cp-viewport {
  position: relative;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
  background: #fff;
}

/* ── Abstract host page ─────────────────────────────────────────────── */
.cp-site {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}
.cp-site-nav {
  flex: 0 0 auto;
  height: 68px;
  display: flex;
  align-items: center;
  gap: 28px;
  padding: 0 56px;
  border-bottom: 1px solid #f0eef5;
}
.cp-nav-logo {
  width: 118px;
  height: 20px;
  border-radius: 6px;
  background: #ddd8e8;
}
.cp-nav-links {
  display: flex;
  gap: 22px;
  margin-left: 20px;
}
.cp-nav-cta { margin-left: auto; }
.cp-nav-link {
  width: 62px;
  height: 10px;
  border-radius: 5px;
  background: #e9e6ef;
}
.cp-nav-cta {
  width: 96px;
  height: 30px;
  border-radius: 8px;
  background: #e4e0ed;
}
.cp-site-main {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  padding: 44px 56px 0;
}
.cp-bar {
  height: 26px;
  border-radius: 8px;
  background: #e2dfea;
}
.cp-bar-xl { width: 620px; }
.cp-bar-lg { width: 430px; }
.cp-line {
  width: 760px;
  height: 12px;
  border-radius: 6px;
  background: #eeecf3;
}
.cp-line-short { width: 590px; }
.cp-cards {
  display: flex;
  gap: 24px;
  margin-top: 18px;
  width: 100%;
}
.cp-card {
  flex: 1 1;
  height: 210px;
  border-radius: 14px;
  background: #f4f2f8;
}

/* Inline iframe embed. The snippet ChannelGuide hands out is
   \`height: 600px; width: 100%; border: none\`, so that is what this is. */
.cp-embed {
  width: 100%;
  height: 600px;
  margin-top: 10px;
  overflow: hidden;
  background: #fff;
  /* Not a real border — the iframe has none. This is the faint edge a browser
     shows where the embedded document starts, kept very light on purpose. */
  box-shadow: 0 0 0 1px #f0eef5;
}

/* Standalone tab: the hosted page fills the viewport. [H] .chat-window is
   max-width 1000 and centred, which is what leaves the white side gutters. */
.cp-standalone {
  height: 100%;
  background: #fff;
}

/* ── Floating launcher + panel [W] ──────────────────────────────────── */
/* Launcher: index.js \`.saicf-chat-widget-icon\` — bottom 20, size + radius
   from the bot's config (defaults 75px / 50%). */
.cp-launcher {
  position: absolute;
  bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.cp-launcher-glyph {
  width: 36px;
  height: 36px;
}
/* Panel: index.js \`.saicf-chat-window\` — 430x620, radius 16, same shadow.
   \`bottom\` is set inline (32px + launcher size) so it clears the launcher. */
.cp-panel {
  position: absolute;
  width: 430px;
  height: 620px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

/* ── The chat surface, shared shell ─────────────────────────────────── */
.cp-surface {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}
/* [H] .chat-window is a centred column up to 1000px on the hosted page. */
.cp-surface-hosted {
  max-width: 1000px;
  margin: 0 auto;
}

/* Header. [W] padding 10px/gutter 10px, title 15/700, logo 30, row min 30.
            [H] padding 12, title 17/700, logo 32, radius 0 0 4px 4px. */
.cp-head {
  flex: 0 0 auto;
  padding: 10px;
}
.cp-surface-hosted .cp-head {
  padding: 12px;
  border-radius: 0 0 4px 4px;
  margin-bottom: 8px;
}
.cp-head-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 30px;
}
.cp-head-left {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.cp-surface-hosted .cp-head-left { gap: 10px; }
/* Header logo — 30px circle in the widget, 32px on the hosted page, both
   cover-cropped. Only rendered when the owner uploaded one; the header keeps
   its height either way via \`.cp-head-row\`'s min-height, which is why the bar
   does not go flatter without a logo (index.js comment on
   \`.saicf-chat-header-title\`). */
.cp-head-logo {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}
.cp-surface-hosted .cp-head-logo { width: 32px; height: 32px; }
.cp-head-title {
  font-size: 15px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cp-surface-hosted .cp-head-title { font-size: 17px; }
.cp-ellipsis {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  opacity: 0.9;
}

/* AI disclosure strip — identical 36px band on both surfaces. */
.cp-disclosure {
  flex: 0 0 auto;
  height: 36px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 10px;
  background: #f7f7f9;
  box-shadow: inset 0 -1px 0 #e9e8ee;
  color: #4a4658;
  font-size: 13px;
}
.cp-surface-hosted .cp-disclosure {
  padding: 0 12px;
  margin-top: -8px;
  margin-bottom: 8px;
}
.cp-disclosure-icon {
  width: 14px;
  height: 14px;
  flex: 0 0 auto;
}
.cp-disclosure-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Message column. [W] body padding 0 10 8; [H] 8px 12px, padding-top 0. */
.cp-body {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 0 10px 8px;
  background: #fff;
  overflow: hidden;
}
.cp-surface-hosted .cp-body { padding: 0 12px 8px; }

.cp-row {
  display: flex;
  align-items: flex-start;
  margin: 5px 0;
}
.cp-surface-hosted .cp-row { margin: 2px 0; }
.cp-row-user { justify-content: flex-end; }

/* [W] avatar 24px, margin-top 7; [H] 28px, margin-top 5, margin-right 8. */
/* The uploaded avatar fills the circle (cover, centred) instead of being
   letterboxed — the tinted background and hairline only show through while the
   image loads, exactly as on the two real surfaces. */
.cp-avatar {
  width: 24px;
  height: 24px;
  margin-top: 7px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.05);
  background-size: cover;
  background-position: center;
  border: 1px solid rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
}
.cp-surface-hosted .cp-avatar {
  width: 28px;
  height: 28px;
  margin-top: 5px;
  margin-right: 8px;
}

.cp-msg {
  border-radius: 8px;
  font-size: 15px;
  line-height: 1.3;
}
.cp-surface-hosted .cp-msg { font-size: 16px; line-height: 1.5; }

.cp-msg-bot {
  max-width: calc(100% - 48px);
  padding: 5px;
  background: #fff;
  color: rgb(43, 43, 43);
}
/* The widget drops the bubble's left padding ONLY when no avatar sits in front
   of it, so the first line starts on the gutter like every other row — the
   shipped rule is \`.saicf-message-row.bot > .saicf-widget-message:first-child\`.
   With an avatar the 5px stays, and that 5px IS the gap between circle and
   text (the row has \`gap: 0\` and the avatar has no right margin). Mirroring
   the \`:first-child\` scope here is what the first version got wrong: it forced
   padding-left to 0 while always drawing an avatar, so the text sat flush
   against the circle — tighter than the real widget ever renders. */
.cp-row-bot > .cp-msg-bot:first-child {
  padding-left: 0;
}
/* The hosted page drops it unconditionally (Chat.css \`.chat-bot-message\`) and
   gets its gap from the avatar's own 8px right margin instead. */
.cp-surface-hosted .cp-msg-bot {
  max-width: 70%;
  padding: 7px;
  padding-left: 0;
  color: #333;
}

/* The one visible behavioural difference between the two surfaces: the widget
   paints the visitor's bubble in the brand colour (set inline), the hosted
   page keeps it neutral grey. [W] .widget-user-message / [H] .chat-user-message */
.cp-msg-user {
  max-width: 80%;
  padding: 8px;
  border-radius: 8px;
}
.cp-surface-hosted .cp-msg-user {
  max-width: 70%;
  padding: 7px;
  border-radius: 10px;
  background: #f2f2f2;
  color: #000;
}

/* Footer: powered-by line, then the input row. */
.cp-foot {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #fff;
}
.cp-powered {
  align-self: center;
  font-size: 10px;
  color: rgb(146, 146, 146);
  text-decoration: underline;
}
/* [W] border-top 1px #f1f1f1, padding 10px gutter, bg #fafafa.
   [H] full 1px border, radius 4, gap 8. */
.cp-input-row {
  display: flex;
  align-items: flex-end;
  gap: 6px;
  padding: 10px;
  background: #fafafa;
  border-top: 1px solid #f1f1f1;
}
.cp-surface-hosted .cp-input-row {
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid #f1f1f1;
  border-radius: 4px;
}
.cp-input {
  flex: 1 1;
  min-width: 0;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background: #fff;
  color: #9a9aa4;
  font-size: 16px;
  line-height: 24px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cp-surface-hosted .cp-input {
  padding: 6px 10px;
  line-height: 1.4;
}
/* [W] send button 44px tall, radius 10, side padding 15. [H] 34px tall. */
.cp-send {
  flex: 0 0 auto;
  height: 44px;
  padding: 0 15px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cp-surface-hosted .cp-send { height: 34px; }
.cp-send-icon {
  width: 16px;
  height: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChannelPreview.css"],"names":[],"mappings":"AAAA;;;;;gEAKgE;;AAEhE;EACE,kBAAkB;EAClB;;;;6DAI2D;EAC3D,sBAAsB;EACtB,WAAW;EACX,4EAA4E;EAC5E,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;iEACiE;AACjE;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,0DAA0D;EAC1D,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,0EAA0E;AAC1E;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;AACA;;2CAE2C;AAC3C;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA,sBAAsB,gBAAgB,EAAE;AACxC,uCAAuC,mBAAmB,EAAE;AAC5D,uCAAuC,mBAAmB,EAAE;AAC5D,uCAAuC,mBAAmB,EAAE;AAC5D;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,0EAA0E;AAC1E;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;AACnB;AACA,cAAc,iBAAiB,EAAE;AACjC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA,aAAa,YAAY,EAAE;AAC3B,aAAa,YAAY,EAAE;AAC3B;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA,iBAAiB,YAAY,EAAE;AAC/B;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;yEACyE;AACzE;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB;4EAC0E;EAC1E,6BAA6B;AAC/B;;AAEA;6EAC6E;AAC7E;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,0EAA0E;AAC1E;iDACiD;AACjD;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;6EAC6E;AAC7E;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA,0EAA0E;AAC1E;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA,0EAA0E;AAC1E;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;wEACwE;AACxE;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;AACA,mCAAmC,SAAS,EAAE;AAC9C;;;;iCAIiC;AACjC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA,mCAAmC,WAAW,EAAE,YAAY,EAAE;AAC9D;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,oCAAoC,eAAe,EAAE;AACrD;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA,gEAAgE;AAChE;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,0EAA0E;AAC1E;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA,8BAA8B,mBAAmB,EAAE;;AAEnD;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;AACA,6BAA6B,aAAa,EAAE;AAC5C,eAAe,yBAAyB,EAAE;;AAE1C,2EAA2E;AAC3E;;sDAEsD;AACtD;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,qCAAqC;EACrC,sBAAsB;EACtB,2BAA2B;EAC3B,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA,6BAA6B,eAAe,EAAE,gBAAgB,EAAE;;AAEhE;EACE,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;AACA;;;;;;;oEAOoE;AACpE;EACE,eAAe;AACjB;AACA;iEACiE;AACjE;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;;kFAEkF;AAClF;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA,iDAAiD;AACjD;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;0CAC0C;AAC1C;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA,0EAA0E;AAC1E;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,8BAA8B,YAAY,EAAE;AAC5C;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":["/* \"What you get\" mockup for the Deploy → Channels modals.\r\n   Everything inside `.cpreview-stage` is drawn at the SHIPPED pixel sizes and\r\n   the whole stage is scaled by JS, so these numbers must stay equal to the\r\n   real ones. Sources are named per block:\r\n     [W] ultimo-bots-widget/src/index.js   (Shadow-DOM panel)\r\n     [H] ultimo-bots-frontend/src/Chat.css (hosted chat page)  */\r\n\r\n.cpreview {\r\n  position: relative;\r\n  /* LOAD-BEARING: the portal has no global border-box reset, so `width: 100%`\r\n     plus the 1px border made this 2px wider than the modal's content column.\r\n     `.channel-modal-body` sets `overflow-y: auto`, which computes overflow-x to\r\n     `auto` as well, so those 2px — the entire right border — were clipped out\r\n     of view. Measured: scrollWidth 782 vs clientWidth 780. */\r\n  box-sizing: border-box;\r\n  width: 100%;\r\n  /* Matches the 1440x810 stage, so the scaled stage fills the band exactly. */\r\n  aspect-ratio: 16 / 9;\r\n  margin-bottom: 18px;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  background: #f4f2f9;\r\n  border: 1px solid #e8e3f5;\r\n}\r\n\r\n/* The Integration tab (Chat link) is a flex column with its own 15px gap, so\r\n   the band's own bottom margin would double the spacing there. */\r\n.integration-tab-content > .cpreview {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.cpreview-stage {\r\n  transform-origin: top left;\r\n  font-family: \"DM Sans\", sans-serif;\r\n  /* The stage carries no interactivity — it is a picture. */\r\n  pointer-events: none;\r\n  user-select: none;\r\n}\r\n\r\n/* ── Browser chrome ─────────────────────────────────────────────────── */\r\n.cp-browser {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: #fff;\r\n}\r\n.cp-browser-bar {\r\n  flex: 0 0 auto;\r\n  height: 52px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 0 20px;\r\n  background: #ece9f4;\r\n  border-bottom: 1px solid #ded9ec;\r\n}\r\n/* macOS traffic lights (close / minimise / zoom), in the order and colours\r\n   Aqua uses since Big Sur. The three dots are the first three children of\r\n   .cp-browser-bar; .cp-url follows them. */\r\n.cp-dot {\r\n  width: 12px;\r\n  height: 12px;\r\n  border-radius: 50%;\r\n  background: #cdc7dd;\r\n}\r\n.cp-dot:first-child { margin-left: 4px; }\r\n.cp-browser-bar .cp-dot:nth-child(1) { background: #ff5f57; }\r\n.cp-browser-bar .cp-dot:nth-child(2) { background: #febc2e; }\r\n.cp-browser-bar .cp-dot:nth-child(3) { background: #28c840; }\r\n.cp-url {\r\n  margin-left: 14px;\r\n  height: 30px;\r\n  min-width: 320px;\r\n  padding: 0 16px;\r\n  display: flex;\r\n  align-items: center;\r\n  border-radius: 15px;\r\n  background: #fff;\r\n  color: #8a8496;\r\n  font-size: 14px;\r\n}\r\n.cp-viewport {\r\n  position: relative;\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n  background: #fff;\r\n}\r\n\r\n/* ── Abstract host page ─────────────────────────────────────────────── */\r\n.cp-site {\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: #fff;\r\n}\r\n.cp-site-nav {\r\n  flex: 0 0 auto;\r\n  height: 68px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 28px;\r\n  padding: 0 56px;\r\n  border-bottom: 1px solid #f0eef5;\r\n}\r\n.cp-nav-logo {\r\n  width: 118px;\r\n  height: 20px;\r\n  border-radius: 6px;\r\n  background: #ddd8e8;\r\n}\r\n.cp-nav-links {\r\n  display: flex;\r\n  gap: 22px;\r\n  margin-left: 20px;\r\n}\r\n.cp-nav-cta { margin-left: auto; }\r\n.cp-nav-link {\r\n  width: 62px;\r\n  height: 10px;\r\n  border-radius: 5px;\r\n  background: #e9e6ef;\r\n}\r\n.cp-nav-cta {\r\n  width: 96px;\r\n  height: 30px;\r\n  border-radius: 8px;\r\n  background: #e4e0ed;\r\n}\r\n.cp-site-main {\r\n  flex: 1;\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 16px;\r\n  padding: 44px 56px 0;\r\n}\r\n.cp-bar {\r\n  height: 26px;\r\n  border-radius: 8px;\r\n  background: #e2dfea;\r\n}\r\n.cp-bar-xl { width: 620px; }\r\n.cp-bar-lg { width: 430px; }\r\n.cp-line {\r\n  width: 760px;\r\n  height: 12px;\r\n  border-radius: 6px;\r\n  background: #eeecf3;\r\n}\r\n.cp-line-short { width: 590px; }\r\n.cp-cards {\r\n  display: flex;\r\n  gap: 24px;\r\n  margin-top: 18px;\r\n  width: 100%;\r\n}\r\n.cp-card {\r\n  flex: 1;\r\n  height: 210px;\r\n  border-radius: 14px;\r\n  background: #f4f2f8;\r\n}\r\n\r\n/* Inline iframe embed. The snippet ChannelGuide hands out is\r\n   `height: 600px; width: 100%; border: none`, so that is what this is. */\r\n.cp-embed {\r\n  width: 100%;\r\n  height: 600px;\r\n  margin-top: 10px;\r\n  overflow: hidden;\r\n  background: #fff;\r\n  /* Not a real border — the iframe has none. This is the faint edge a browser\r\n     shows where the embedded document starts, kept very light on purpose. */\r\n  box-shadow: 0 0 0 1px #f0eef5;\r\n}\r\n\r\n/* Standalone tab: the hosted page fills the viewport. [H] .chat-window is\r\n   max-width 1000 and centred, which is what leaves the white side gutters. */\r\n.cp-standalone {\r\n  height: 100%;\r\n  background: #fff;\r\n}\r\n\r\n/* ── Floating launcher + panel [W] ──────────────────────────────────── */\r\n/* Launcher: index.js `.saicf-chat-widget-icon` — bottom 20, size + radius\r\n   from the bot's config (defaults 75px / 50%). */\r\n.cp-launcher {\r\n  position: absolute;\r\n  bottom: 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n}\r\n.cp-launcher-glyph {\r\n  width: 36px;\r\n  height: 36px;\r\n}\r\n/* Panel: index.js `.saicf-chat-window` — 430x620, radius 16, same shadow.\r\n   `bottom` is set inline (32px + launcher size) so it clears the launcher. */\r\n.cp-panel {\r\n  position: absolute;\r\n  width: 430px;\r\n  height: 620px;\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n/* ── The chat surface, shared shell ─────────────────────────────────── */\r\n.cp-surface {\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: #fff;\r\n}\r\n/* [H] .chat-window is a centred column up to 1000px on the hosted page. */\r\n.cp-surface-hosted {\r\n  max-width: 1000px;\r\n  margin: 0 auto;\r\n}\r\n\r\n/* Header. [W] padding 10px/gutter 10px, title 15/700, logo 30, row min 30.\r\n            [H] padding 12, title 17/700, logo 32, radius 0 0 4px 4px. */\r\n.cp-head {\r\n  flex: 0 0 auto;\r\n  padding: 10px;\r\n}\r\n.cp-surface-hosted .cp-head {\r\n  padding: 12px;\r\n  border-radius: 0 0 4px 4px;\r\n  margin-bottom: 8px;\r\n}\r\n.cp-head-row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  min-height: 30px;\r\n}\r\n.cp-head-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  min-width: 0;\r\n}\r\n.cp-surface-hosted .cp-head-left { gap: 10px; }\r\n/* Header logo — 30px circle in the widget, 32px on the hosted page, both\r\n   cover-cropped. Only rendered when the owner uploaded one; the header keeps\r\n   its height either way via `.cp-head-row`'s min-height, which is why the bar\r\n   does not go flatter without a logo (index.js comment on\r\n   `.saicf-chat-header-title`). */\r\n.cp-head-logo {\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n  flex-shrink: 0;\r\n}\r\n.cp-surface-hosted .cp-head-logo { width: 32px; height: 32px; }\r\n.cp-head-title {\r\n  font-size: 15px;\r\n  font-weight: 700;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n.cp-surface-hosted .cp-head-title { font-size: 17px; }\r\n.cp-ellipsis {\r\n  width: 16px;\r\n  height: 16px;\r\n  flex-shrink: 0;\r\n  opacity: 0.9;\r\n}\r\n\r\n/* AI disclosure strip — identical 36px band on both surfaces. */\r\n.cp-disclosure {\r\n  flex: 0 0 auto;\r\n  height: 36px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 0 10px;\r\n  background: #f7f7f9;\r\n  box-shadow: inset 0 -1px 0 #e9e8ee;\r\n  color: #4a4658;\r\n  font-size: 13px;\r\n}\r\n.cp-surface-hosted .cp-disclosure {\r\n  padding: 0 12px;\r\n  margin-top: -8px;\r\n  margin-bottom: 8px;\r\n}\r\n.cp-disclosure-icon {\r\n  width: 14px;\r\n  height: 14px;\r\n  flex: 0 0 auto;\r\n}\r\n.cp-disclosure-text {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n/* Message column. [W] body padding 0 10 8; [H] 8px 12px, padding-top 0. */\r\n.cp-body {\r\n  flex: 1;\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 0 10px 8px;\r\n  background: #fff;\r\n  overflow: hidden;\r\n}\r\n.cp-surface-hosted .cp-body { padding: 0 12px 8px; }\r\n\r\n.cp-row {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  margin: 5px 0;\r\n}\r\n.cp-surface-hosted .cp-row { margin: 2px 0; }\r\n.cp-row-user { justify-content: flex-end; }\r\n\r\n/* [W] avatar 24px, margin-top 7; [H] 28px, margin-top 5, margin-right 8. */\r\n/* The uploaded avatar fills the circle (cover, centred) instead of being\r\n   letterboxed — the tinted background and hairline only show through while the\r\n   image loads, exactly as on the two real surfaces. */\r\n.cp-avatar {\r\n  width: 24px;\r\n  height: 24px;\r\n  margin-top: 7px;\r\n  border-radius: 50%;\r\n  background-color: rgba(0, 0, 0, 0.05);\r\n  background-size: cover;\r\n  background-position: center;\r\n  border: 1px solid rgba(0, 0, 0, 0.08);\r\n  flex-shrink: 0;\r\n}\r\n.cp-surface-hosted .cp-avatar {\r\n  width: 28px;\r\n  height: 28px;\r\n  margin-top: 5px;\r\n  margin-right: 8px;\r\n}\r\n\r\n.cp-msg {\r\n  border-radius: 8px;\r\n  font-size: 15px;\r\n  line-height: 1.3;\r\n}\r\n.cp-surface-hosted .cp-msg { font-size: 16px; line-height: 1.5; }\r\n\r\n.cp-msg-bot {\r\n  max-width: calc(100% - 48px);\r\n  padding: 5px;\r\n  background: #fff;\r\n  color: rgb(43, 43, 43);\r\n}\r\n/* The widget drops the bubble's left padding ONLY when no avatar sits in front\r\n   of it, so the first line starts on the gutter like every other row — the\r\n   shipped rule is `.saicf-message-row.bot > .saicf-widget-message:first-child`.\r\n   With an avatar the 5px stays, and that 5px IS the gap between circle and\r\n   text (the row has `gap: 0` and the avatar has no right margin). Mirroring\r\n   the `:first-child` scope here is what the first version got wrong: it forced\r\n   padding-left to 0 while always drawing an avatar, so the text sat flush\r\n   against the circle — tighter than the real widget ever renders. */\r\n.cp-row-bot > .cp-msg-bot:first-child {\r\n  padding-left: 0;\r\n}\r\n/* The hosted page drops it unconditionally (Chat.css `.chat-bot-message`) and\r\n   gets its gap from the avatar's own 8px right margin instead. */\r\n.cp-surface-hosted .cp-msg-bot {\r\n  max-width: 70%;\r\n  padding: 7px;\r\n  padding-left: 0;\r\n  color: #333;\r\n}\r\n\r\n/* The one visible behavioural difference between the two surfaces: the widget\r\n   paints the visitor's bubble in the brand colour (set inline), the hosted\r\n   page keeps it neutral grey. [W] .widget-user-message / [H] .chat-user-message */\r\n.cp-msg-user {\r\n  max-width: 80%;\r\n  padding: 8px;\r\n  border-radius: 8px;\r\n}\r\n.cp-surface-hosted .cp-msg-user {\r\n  max-width: 70%;\r\n  padding: 7px;\r\n  border-radius: 10px;\r\n  background: #f2f2f2;\r\n  color: #000;\r\n}\r\n\r\n/* Footer: powered-by line, then the input row. */\r\n.cp-foot {\r\n  flex: 0 0 auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  background: #fff;\r\n}\r\n.cp-powered {\r\n  align-self: center;\r\n  font-size: 10px;\r\n  color: rgb(146, 146, 146);\r\n  text-decoration: underline;\r\n}\r\n/* [W] border-top 1px #f1f1f1, padding 10px gutter, bg #fafafa.\r\n   [H] full 1px border, radius 4, gap 8. */\r\n.cp-input-row {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  gap: 6px;\r\n  padding: 10px;\r\n  background: #fafafa;\r\n  border-top: 1px solid #f1f1f1;\r\n}\r\n.cp-surface-hosted .cp-input-row {\r\n  gap: 8px;\r\n  padding: 10px 12px;\r\n  border: 1px solid #f1f1f1;\r\n  border-radius: 4px;\r\n}\r\n.cp-input {\r\n  flex: 1;\r\n  min-width: 0;\r\n  padding: 10px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 8px;\r\n  background: #fff;\r\n  color: #9a9aa4;\r\n  font-size: 16px;\r\n  line-height: 24px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n.cp-surface-hosted .cp-input {\r\n  padding: 6px 10px;\r\n  line-height: 1.4;\r\n}\r\n/* [W] send button 44px tall, radius 10, side padding 15. [H] 34px tall. */\r\n.cp-send {\r\n  flex: 0 0 auto;\r\n  height: 44px;\r\n  padding: 0 15px;\r\n  border-radius: 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.cp-surface-hosted .cp-send { height: 34px; }\r\n.cp-send-icon {\r\n  width: 16px;\r\n  height: 16px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
